import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingFonts } from 'helpers/constants';

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: ERebrandingFonts.OPENSANS,
    color: '#546E7A',
  },
  fieldset: {
    position: 'relative',
    paddingBottom: 10,
    paddingTop: 4,
    paddingLeft: theme.spacing(1.5),
    backgroundColor: '#fff',
    border: '1px solid #B0BEC5',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgb(0 123 255 / 25%)',
    },
    '&.--error': {
      borderColor: '#dc3f53',
      '& label': {
        color: '#dc3f53',
      },
    },
    '& label': {
      fontSize: 12,
      top: -20,
      position: 'absolute',
      left: 44,
      fontWeight: 600,
    },
    '& legend': {
      fontSize: 13.3,
      marginLeft: 27,
      visibility: 'hidden',
    },
  },
  content: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    marginTop: -2,
    fontSize: 14,
  },
  uploadIcon: {
    marginRight: theme.spacing(1.5),
  },
  removeFileIconBtn: {
    position: 'absolute',
    right: theme.spacing(1.5),
  },
  helperTextContainer: {
    marginTop: theme.spacing(1),
    fontSize: 10,
    fontFamily: ERebrandingFonts.OPENSANS,
  },
  helperText: {
    color: '#072D83',
  },
  errorMessage: {
    color: '#dc3f53',
  },
}));
